import { axios } from "../core/axios.interceptor";

const baseURL = `user-api-key`;

export async function getAllKeys() {
    const response = await axios.get(`${baseURL}`);
    return response;
}
export async function addNewApiKey(model) {
    const response = await axios.post(`${baseURL}`, model);
    return response;
}

export async function deleteAPIKey(uId) {
    const response = await axios.delete(`${baseURL}/${uId}`);
    return response;
}